import { render } from "./SprintsView.vue?vue&type=template&id=5383b523&scoped=true"
import script from "./SprintsView.vue?vue&type=script&lang=js"
export * from "./SprintsView.vue?vue&type=script&lang=js"

import "./SprintsView.vue?vue&type=style&index=0&id=5383b523&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5383b523"]])

export default __exports__